export { default as CostQuotationSlot } from './CostQuotationSlot';
